import React from 'react';

const paths = {
  projects: 'M3 7h7l2 2h9v11H3z M3 7V4h7l2 3',
  skills: 'M4 4h6a3 3 0 0 1 3 3v14a4 4 0 0 0-4-2H4z M13 7a3 3 0 0 1 3-3h5v15h-4a4 4 0 0 0-4 2',
  agents: 'M8 4h8v4H8z M12 8v4 M4 12h16 M4 12v4 M20 12v4 M1 16h6v5H1z M17 16h6v5h-6z M9 16h6v5H9z M12 12v4',
  settings: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M9 3h6l1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1z',
  admin: 'M12 3l8 3v6c0 5-8 9-8 9s-8-4-8-9V6z M8 12l3 3 5-6',
  sun: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M12 2v2 M12 20v2 M2 12h2 M20 12h2 M5 5l1.5 1.5 M17.5 17.5L19 19 M5 19l1.5-1.5 M17.5 6.5L19 5',
  moon: 'M20 15A9 9 0 0 1 9 4a9 9 0 1 0 11 11z',
  menu: 'M4 6h16 M4 12h16 M4 18h16',
  collapse: 'M4 4h16v16H4z M9 4v16 M16 9l-3 3 3 3',
  close: 'M6 6l12 12 M18 6L6 18',
  plus: 'M12 5v14 M5 12h14',
  arrow: 'M5 12h14 M13 6l6 6-6 6',
  back: 'M19 12H5 M11 6l-6 6 6 6',
  logout: 'M9 4H4v16h5 M9 12h12 M16 7l5 5-5 5',
  spark: 'M12 3l2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z',
  send: 'M21 3L9 15 M21 3l-7 18-5-6-6-5z',
  chevron: 'M9 5l7 7-7 7',
  folder: 'M3 7V4h7l2 3h9v13H3z',
  more: 'M5 12h.01 M12 12h.01 M19 12h.01',
  search: 'M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14 M15 15l6 6',
  document: 'M14 3H5v18h14V8z M14 3v5h5 M8 12h8 M8 16h6',
  table: 'M3 4h18v16H3z M3 9h18 M3 14h18 M9 4v16',
  slides: 'M3 3h18v14H3z M12 17v4 M7 21h10 M7 12V9 M12 12V6 M17 12V8',
  inherit: 'M5 4v10a4 4 0 0 0 4 4h11 M16 14l4 4-4 4 M2 7l3-3 3 3',
  check: 'M5 12l4 4L19 6',
};

export default function Icon({ name, size = 20, ...props }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <path d={paths[name] || paths.spark} />
  </svg>;
}
